import * as React from "react";

/**
 * The `data-app-scope` of the enclosing `AppView`. Its theme's tokens are set
 * on that attribute, so anything rendered outside the view's DOM (a portaled
 * menu) carries it to keep the App's colors.
 */
export const AppScopeContext = React.createContext<string | undefined>(
  undefined,
);

/** Props that put an element, wherever it is mounted, in the App's theme. */
export function useAppScopeProps(): { "data-app-scope"?: string } {
  const scope = React.use(AppScopeContext);
  return scope ? { "data-app-scope": scope } : {};
}

/**
 * The compiled CSS of the enclosing `AppView`'s theme. It lives in a scoped
 * `<style>` tag that no DOM observer sees change, so anything that reads
 * theme tokens once (a chart) re-reads them when this changes.
 */
export const AppThemeCssContext = React.createContext<string>("");

/** Optional host controls for the table's currently visible rows. */
export const AppTableActionsContext = React.createContext<
  ((columns: string[], rows: string[][]) => React.ReactNode) | undefined
>(undefined);
